<template>

  <v-container fluid v-if="order">
    <!-- Ordered Item Count and Total -->
    <template v-if="showHeading">
      <v-row no-gutters class="align-center">
        <v-col>
          <div style="color:#727272;" class="text-h6">Total: <span class="font-weight-bold">{{ formatTotal(orderDetails.total) }}</span></div>
          <div class="mt-4">Items: {{ totalItems }}</div>
        </v-col>
      </v-row>
    </template>

    <!-- Ordered Items -->
    <v-row>
      <v-col cols="12" class="pa-0 ma-0 mt-2">
        <v-data-table
            hide-default-footer
            disable-pagination
            :headers="headers"
            :items="orderedItems">

          <!-- line total -->
          <template v-slot:[`item.item_total`]="{ item }">
            <span>{{ formatTotal(item.item_total) }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Thirdparty Notes (from provider platform) -->
    <v-row class="mt-6" v-if="platformNotes && showNotes">
      <v-col cols="12" class="mt-4">
        <div class="text-h6">Notes:</div>
        <div class="mt-4">{{ platformNotes }}</div>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

export default {
  name: 'OrderShipmentDetails',

  data () {
    return {
      headers: [
        // { text: 'Product ID', value: 'product_id' },
        { text: 'Batch Number', value: 'batch_number' },
        { text: 'Description', value: 'product_label' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Total (USD)', value: 'item_total' }
      ]
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    },
    showHeading: {
      type: Boolean,
      default: true
    },
    showNotes: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    orderDetails () {
      return this.order.order_details
    },
    orderedItems () {
      return this.orderDetails.item_data.items
    },
    totalItems () {
      return this.orderedItems.length
    },
    platformNotes () {
      return this.order.thirdparty_notes
    }
  },

  methods: {
    formatTotal (total) {
      const totalAsNum = total || 0
      return `$${Number(totalAsNum).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
    }
  }
}
</script>

<style scoped>
</style>
